import React, { useCallback } from 'react'
import { Card } from 'primereact/card'
import { Button } from 'primereact/button'
import './informacoes-pix-automatico.scss'
import './ContratoForm.scss'
import '../../../index.scss'
import LtsLookupConfiguracaoPixAutomatico from '../../../components/lottus/lts-lookup-configuracao-pixautomatico'
import LtsInputText from '../../../components/lottus/lts-input-text'
import { getMessage } from '../../../utils'
import apiService from '../../../services/api.service'
import _ from 'lodash'

const FIELD_NAMES = {
  configuracaoPix: 'configuracaoPixAutomatico',
  descricaoPixAutomatico: 'descricaoPixAutomatico',
}

export default function InformacoesPixAutomatico(props) {
  const { plano, messages, history, setField, toastRef } = props

  // Formata data de YYYY-MM-DD para DD/MM/YYYY
  const formatarDataBrasil = useCallback((dataString) => {
    if (!dataString) return ''

    const data = new Date(dataString)
    if (isNaN(data.getTime())) return dataString

    const dia = String(data.getDate()).padStart(2, '0')
    const mes = String(data.getMonth() + 1).padStart(2, '0')
    const ano = data.getFullYear()

    return `${dia}/${mes}/${ano}`
  }, [])

  // Manipula mudança na configuração do Pix Automático
  const handleConfiguracaoChange = useCallback(
    (data) => {
      const configuracaoPix = {
        id: data?.oid ?? null,
        value: data?.nome ?? '',
      }

      setField(FIELD_NAMES.configuracaoPix, configuracaoPix)
    },
    [setField]
  )

  const handledescricaoPixAutomaticoChange = useCallback(
    (data) => {
      setField(FIELD_NAMES.descricaoPixAutomatico, data)
    },
    [setField]
  )

  // Atualiza status da recorrência PIX consultando o backend
  const handleAtualizarStatus = useCallback(() => {
    const idRec = plano?.recorrenciaPix?.idRec

    if (!idRec) {
      if (toastRef?.current) {
        toastRef.current.show({
          severity: 'warn',
          summary: 'Aviso',
          detail: 'ID da recorrência não encontrado',
          life: 3000,
        })
      }
      return
    }

    apiService
      .get(`/lottustech/pixautomatico/atualizarRecorrencia/${idRec}`)
      .then((response) => {
        const data = _.get(response, 'data', {})

        // Atualiza os campos de recorrenciaPix com os dados retornados
        const recorrenciaAtualizada = {
          oid: _.get(data, 'oid', plano.recorrenciaPix.oid),
          oidContratoPlano: _.get(data, 'oidContratoPlano', plano.recorrenciaPix.oidContratoPlano),
          idRec: _.get(data, 'idRec', plano.recorrenciaPix.idRec),
          status: _.get(data, 'status', plano.recorrenciaPix.status),
          tipoJornada: _.get(data, 'tipoJornada', plano.recorrenciaPix.tipoJornada),
          codigoPsp: _.get(data, 'codigoPsp', plano.recorrenciaPix.codigoPsp),
          pixCopiaCola: _.get(data, 'pixCopiaCola', plano.recorrenciaPix.pixCopiaCola),
          idLocation: _.get(data, 'idLocation', plano.recorrenciaPix.idLocation),
          urlLocation: _.get(data, 'urlLocation', plano.recorrenciaPix.urlLocation),
          dataCriacaoLocation: _.get(data, 'dataCriacaoLocation', plano.recorrenciaPix.dataCriacaoLocation),
          dataCriacao: _.get(data, 'dataCriacao', plano.recorrenciaPix.dataCriacao),
          dataConfirmacao: _.get(data, 'dataConfirmacao', plano.recorrenciaPix.dataConfirmacao),
          response: _.get(data, 'response', plano.recorrenciaPix.response),
        }

        setField('recorrenciaPix', recorrenciaAtualizada)

        if (toastRef?.current) {
          toastRef.current.show({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Status atualizado com sucesso',
            life: 3000,
          })
        }
      })
      .catch((error) => {
        console.error('Erro ao atualizar status:', error)
        if (toastRef?.current) {
          toastRef.current.show({
            severity: 'error',
            summary: 'Erro',
            detail: 'Falha ao atualizar o status da recorrência',
            life: 3000,
          })
        }
      })
  }, [plano?.recorrenciaPix?.idRec, plano?.recorrenciaPix, setField, toastRef])

  // Copia conteúdo do Pix Copia e Cola para área de transferência
  const handleCopyPix = useCallback(() => {
    if (plano?.recorrenciaPix?.pixCopiaCola) {
      navigator.clipboard
        .writeText(plano.recorrenciaPix.pixCopiaCola)
        .then(() => {
          if (toastRef?.current) {
            toastRef.current.show({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Pix copiado para a área de transferência',
              life: 3000,
            })
          }
        })
        .catch((err) => {
          if (toastRef?.current) {
            toastRef.current.show({
              severity: 'error',
              summary: 'Erro',
              detail: 'Falha ao copiar o pix',
              life: 3000,
            })
          }
        })
    }
  }, [plano?.recorrenciaPix?.pixCopiaCola, toastRef])

  return (
    <Card
      className="informacoes-pix-automatico"
      subTitle={getMessage(messages, 'contrato.label.plano.informacoesPixAutomatico')}
    >
      <div className="p-grid p-fluid form-group">
        <div className="p-col-12 p-sm-6 p-md-6 p-lg-6 p-xl-6">
          <LtsLookupConfiguracaoPixAutomatico
            label={getMessage(messages, 'contrato.label.plano.configuracaoPixAutomatico')}
            value={plano?.configuracaoPixAutomatico?.value ?? ''}
            oidRecord={plano?.configuracaoPixAutomatico?.id ?? ''}
            history={history}
            onChange={handleConfiguracaoChange}
          />
        </div>
        <div className="p-col-12 p-sm-6 p-md-6 p-lg-6 p-xl-6 fix-float-label">
          <LtsInputText
            label={getMessage(messages, 'contrato.label.plano.descricaoPixAutomatico')}
            value={plano.descricaoPixAutomatico}
            name="descricaoPixAutomatico"
            onChange={handledescricaoPixAutomaticoChange}
          />
        </div>
      </div>
      <div className="p-grid p-fluid form-group p-mt-1">
        {plano?.recorrenciaPix?.idRec && (
          <div className="p-col-12 p-sm-6 p-md-6 p-lg-6 p-xl-6 fix-float-label">
            <LtsInputText
              label={getMessage(messages, 'contrato.label.plano.idRec')}
              value={plano.recorrenciaPix.idRec}
              disabled={true}
              name="idRec"
            />
          </div>
        )}

        {plano?.recorrenciaPix?.status && (
          <div className="p-col-12 p-sm-6 p-md-6 p-lg-6 p-xl-6">
            <LtsInputText
              label={getMessage(messages, 'contrato.label.plano.status')}
              value={plano.recorrenciaPix.status}
              disabled={true}
              name="status"
              button={
                <Button
                  icon="pi pi-sync"
                  onClick={handleAtualizarStatus}
                  tooltip="Consultar e Atualizar Status"
                  tooltipOptions={{ position: 'top' }}
                  className="p-button-outlined"
                />
              }
            />
          </div>
        )}

        {plano?.recorrenciaPix?.pixCopiaCola && (
          <div className="p-col-12">
            <LtsInputText
              label={getMessage(messages, 'contrato.label.plano.pixCopiaCola')}
              value={plano.recorrenciaPix.pixCopiaCola}
              disabled={true}
              name="pixCopiaCola"
              button={
                <Button
                  icon="pi pi-copy"
                  onClick={handleCopyPix}
                  tooltip="Copiar Pix"
                  tooltipOptions={{ position: 'top' }}
                  className="p-button-outlined"
                />
              }
            />
          </div>
        )}
        {plano?.recorrenciaPix?.response?.calendario?.dataInicial && (
          <div className="p-col-12 p-sm-3">
            <LtsInputText
              label={getMessage(messages, 'contrato.label.plano.recorrencia.datainicial')}
              value={formatarDataBrasil(plano.recorrenciaPix.response.calendario.dataInicial)}
              disabled={true}
              name="recorrenciaDataInicial"
            />
          </div>
        )}
      </div>
    </Card>
  )
}
